import React, { Component } from 'react';
import { Link } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import Header from '../../components/Header';
import Bugsnag from '../../helpers/bugsnag';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withInventoryFilter from '../../common/withInventoryFilter';
import { onGoBack } from '../../common/globals';
import {
  getAccountName,
  getInventory,
  getInventoryBySessionID,
  getInventoryScanProductByAccNameAndType,
  getInventoryScanProductByType,
  getInventoryScanProductExtDevByAccNameAndType,
  getInventoryScanProductManualByAccNameAndType,
} from '../../utils/db';

class SessionFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterCases: {},
      inventoryScan: {},
      isChecked: '',
      isScanOnly: '',
      isExpire: '',
      inventoryTypeCount: {},
      screenWidth: '',
      updatedFilters: {}
    };
  }

  _goBack = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onUnselectValue = async (key, index) => {
    try {
      const { inventoryFilter, setInventoryFilter, setLoader } = this.props;
      const { filterCases } = this.state;

      setLoader(true);
      if (filterCases[key].length > 1) {
        filterCases[key].splice(index, 1);
      } else {
        if (key === 'ExpireDate') {
          delete inventoryFilter.isExpire;
          delete inventoryFilter.ExpiringDay;
        }
        if (key === 'InventoryComparison') {
          delete inventoryFilter.Variance;
          delete inventoryFilter.isChecked;
        }
        delete inventoryFilter[key];
        delete filterCases[key];
      }
      // Update Filters after removing unused key-values
      let updatedFilters = _.omit(inventoryFilter, 'AccountName');
      if (inventoryFilter.hasOwnProperty('isScanOnly')) {
        updatedFilters = _.omit(updatedFilters, 'isScanOnly');
      }
      if (inventoryFilter.hasOwnProperty('OrderBy') && updatedFilters.OrderBy[0] === 'PRODUCT #') {
        updatedFilters = _.omit(updatedFilters, 'OrderBy');
      }
      if (inventoryFilter.hasOwnProperty('InventoryComparison')) {
        updatedFilters = _.omit(updatedFilters, 'Variance');
        updatedFilters = _.omit(updatedFilters, 'isChecked');
      }
      if (inventoryFilter.hasOwnProperty('isExpire')) {
        updatedFilters = _.omit(updatedFilters, 'isExpire');
        updatedFilters = _.omit(updatedFilters, 'ExpiringDay');
      }
      setInventoryFilter(inventoryFilter);
      this.setState({ filterCases, updatedFilters }, () => {
        this._onGetInventoryProduct();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetInventory = async (groupedData) => {
    try {
      let inventoryScan = {};
      const { inventoryFilter } = this.props;
      Object.keys(groupedData).map(async (data) => {
        let par = 0; let congin = 0; let
          scan = 0;
        groupedData[data].map((item) => {
          if (item.InventoryType === 'PAR') {
            par += 1;
          } else if (item.InventoryType === 'CONSIGN') {
            congin += 1;
          } else if (item.InventoryType === 'SCAN' || item.InventoryType === 'MANUAL' || item.InventoryType === 'EXTDEVICE') {
            scan += item.Qty;
          }
        });
        inventoryScan = Object.assign(
          inventoryScan,
          {
            [data]: {
              PAR: par,
              CONSIGN: congin,
              SCAN: scan,
              AccountName: data,
              data: groupedData[data]
            }
          }
        );
      });
      const finalObj = {};
      const inventoryPromiseAll = Object.keys(inventoryScan).map(async (data) => {
        inventoryScan[data].data.map((value) => new Promise((resolve) => {
          resolve(true);
          if (finalObj[value.AccountName]) {
            const booleanValue = finalObj[value.AccountName]
              .ProductNo.filter((item) => item.ProductNo === value.ProductNo).length > 0;
            if (booleanValue) {
              finalObj[value.AccountName].ProductNo.map((item) => {
                if (item.ProductNo === value.ProductNo) {
                  item.LotNo.push({
                    SCAN: (value.InventoryType === 'SCAN' || value.InventoryType === 'MANUAL' || value.InventoryType === 'EXTDEVICE')
                      ? Number(value.Qty) : 0,
                    PAR: value.InventoryType === 'PAR' ? Number(value.Qty) : 0,
                    CONSIGN: value.InventoryType === 'CONSIGN' ? Number(value.Qty) : 0,
                    ExpireDate: value.ExpireDate,
                    LotNo: value.LotNo,
                    ProductNo: value.ProductNo,
                    InventoryType: value.InventoryType,
                    ID: value.ID
                  });
                }
              });
            } else {
              finalObj[value.AccountName].ProductNo.push({
                AccountAbb: value.AccountAbb,
                AccountNo: value.AccountNo,
                InventoryType: value.InventoryType,
                OfficeName: value.OfficeName,
                TeamName: value.TeamName,
                UpdateDate: value.UpdateDate,
                LotNo: [{
                  SCAN: (value.InventoryType === 'SCAN' || value.InventoryType === 'MANUAL' || value.InventoryType === 'EXTDEVICE')
                    ? Number(value.Qty) : 0,
                  PAR: value.InventoryType === 'PAR' ? Number(value.Qty) : 0,
                  CONSIGN: value.InventoryType === 'CONSIGN' ? Number(value.Qty) : 0,
                  ExpireDate: value.ExpireDate,
                  LotNo: value.LotNo,
                  ProductNo: value.ProductNo,
                  InventoryType: value.InventoryType,
                  ID: value.ID
                }],
                AccountName: value.AccountName,
                ProductNo: value.ProductNo,
                ProductDescription: value.ProductDescription,
                ID: value.ID
              });
            }
          } else {
            const {
              InventoryType,
              OfficeName,
              ProductDescription,
              ProductNo,
              Qty,
              TeamName,
              LotNo,
              AccountName,
              ID,
              SCAN,
              UpdateDate, ExpireDate, ...rest
            } = value;
            finalObj[value.AccountName] = {
              ...rest,
              PAR: inventoryScan[data].PAR,
              CONSIGN: inventoryScan[data].CONSIGN,
              SCAN: inventoryScan[data].SCAN,
            };
            finalObj[value.AccountName].ProductNo
              = [{
                InventoryType,
                OfficeName,
                ProductDescription,
                ProductNo,
                Qty,
                TeamName,
                UpdateDate,
                AccountName,
                ID,
                LotNo: [{
                  SCAN: (value.InventoryType === 'SCAN' || value.InventoryType === 'MANUAL' || value.InventoryType === 'EXTDEVICE')
                    ? Number(Qty) : 0,
                  PAR: value.InventoryType === 'PAR' ? Number(Qty) : 0,
                  CONSIGN: value.InventoryType === 'CONSIGN' ? Number(Qty) : 0,
                  ExpireDate,
                  LotNo,
                  ProductNo,
                  InventoryType,
                  ID
                }],
                ExpireDate
              }];
          }
        }));
      });
      await Promise.all(inventoryPromiseAll);
      const inventoryScanPromiseAll = Object.keys(finalObj).map(async (data) => {
        finalObj[data].ProductNo.map((value) => new Promise((resolve) => {
          const lotData = [];
          resolve(true);
          value.LotNo.map((lot) => {
            const booleanValue = lotData.filter((item) => item.LotNo === lot.LotNo).length > 0;
            if (booleanValue) {
              lotData.map((item) => {
                if (item.LotNo === lot.LotNo) {
                  item.SCAN += lot.SCAN;
                  item.PAR += lot.PAR;
                  item.CONSIGN += lot.CONSIGN;
                }
              });
            } else {
              lotData.push({
                SCAN: (lot.InventoryType === 'SCAN' || lot.InventoryType === 'MANUAL' || lot.InventoryType === 'EXTDEVICE')
                  ? lot.SCAN : 0,
                PAR: lot.InventoryType === 'PAR' ? lot.PAR : 0,
                CONSIGN: lot.InventoryType === 'CONSIGN' ? lot.CONSIGN : 0,
                ExpireDate: lot.ExpireDate,
                LotNo: lot.LotNo,
                ProductNo: lot.ProductNo,
                InventoryType: lot.InventoryType,
                ID: lot.ID
              });
            }
          });
          value.LotNo = lotData;
        }));
      });
      await Promise.all(inventoryScanPromiseAll);
      if (inventoryFilter.hasOwnProperty('InventoryComparison')) {
        if (Object.keys(finalObj).length > 0) {
          Object.keys(finalObj).map((value) => {
            finalObj[value].ProductNo.map((item) => {
              item.LotNo.map((lot) => {
                if (inventoryFilter.Variance[0] === 'PRODUCT') {
                  if (inventoryFilter.InventoryComparison[0] === 'CONSIGNMENT vs SCANS (S-C)') {
                    lot.variance = lot.SCAN - lot.CONSIGN;
                  } else if (inventoryFilter.InventoryComparison[0] === 'PAR vs CONSIGNMENT (C-P)') {
                    lot.variance = lot.CONSIGN - lot.PAR;
                  } else if (inventoryFilter.InventoryComparison[0] === 'PAR vs SCANS (S-P)') {
                    lot.variance = lot.SCAN - lot.PAR;
                  }
                } else if (inventoryFilter.Variance[0] === 'LOT') {
                  if (inventoryFilter.InventoryComparison[0] === 'CONSIGNMENT vs SCANS (S-C)') {
                    lot.variance = lot.SCAN - lot.CONSIGN;
                  } else if (inventoryFilter.InventoryComparison[0] === 'PAR vs CONSIGNMENT (C-P)') {
                    lot.variance = lot.CONSIGN - lot.PAR;
                  } else if (inventoryFilter.InventoryComparison[0] === 'PAR vs SCANS (S-P)') {
                    lot.variance = lot.SCAN - lot.PAR;
                  }
                }
              });
            });
          });
        }
      }
      if (inventoryFilter.hasOwnProperty('isChecked')) {
        if (inventoryFilter.isChecked[0] === 'checked') {
          if (inventoryFilter.Variance[0] === 'PRODUCT') {
            const hideVariancePromiseAll = Object.keys(finalObj).map(async (data) => {
              const productValue = [];
              finalObj[data].ProductNo.map((item) => new Promise((resolve) => {
                resolve(true);
                const varianceExist = item.LotNo.some((ele) => (ele.variance > 0
                  || ele.variance < 0));
                if (varianceExist) {
                  productValue.push(item);
                }
                finalObj[data].ProductNo = productValue;
              }));
            });
            await Promise.all(hideVariancePromiseAll);
          }
        }
      }
      this.setState({
        inventoryScan: finalObj
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getInventoryCount = (inventoryTypeCount) => {
    let inventoryScanCountObj = {};
    Object.keys(inventoryTypeCount).map(async (data) => {
      let par = 0; let congin = 0; let
        scan = 0;
      inventoryTypeCount[data].map((item) => {
        if (item.InventoryType === 'PAR') {
          par += 1;
        } else if (item.InventoryType === 'CONSIGN') {
          congin += 1;
        } else if (item.InventoryType === 'SCAN' || item.InventoryType === 'MANUAL' || item.InventoryType === 'EXTDEVICE') {
          scan += item.Qty;
        }
      });
      inventoryScanCountObj = Object.assign(
        inventoryScanCountObj,
        {
          [data]: {
            PAR: par,
            CONSIGN: congin,
            SCAN: scan,
          }
        }
      );
    });
    this.setState({
      inventoryTypeCount: inventoryScanCountObj
    });
  }

  _onGetInventoryProduct = async () => {
    try {
      const { inventoryFilter, setLoader } = this.props;
      const accountNameRes = await getAccountName();
      accountNameRes.map((item) => {
        item.ExpireDate = moment(item.ExpireDate).format('MM/DD/YYYY');
      });
      const inventoryRes = await getInventory();
      inventoryRes.map((value) => {
        value.ExpireDate = moment(value.ExpireDate).format('MM/DD/YYYY');
        value.InventoryType = value.ProductEnterType;
      });
      inventoryRes.map((value) => {
        if (value.InventoryType === 'MANUAL' || value.InventoryType === 'EXTDEVICE') {
          value.InventoryType = 'SCAN';
        }
      });

      const mergeInventoryAndInventoryScan = accountNameRes.concat(inventoryRes);
      const inventoryScan = _.groupBy(mergeInventoryAndInventoryScan, 'AccountName');
      const inventoryTypeCount = _.groupBy(mergeInventoryAndInventoryScan, 'AccountName');
      this._getInventoryCount(inventoryTypeCount);
      if (inventoryFilter.hasOwnProperty('AccountName')) {
        Object.keys(inventoryScan).map(async (data) => {
          inventoryScan[data] = inventoryScan[data].filter((
            { AccountName }
          ) => inventoryFilter.AccountName.indexOf(AccountName) > -1);
        });
      }
      if (inventoryFilter.hasOwnProperty('Product')) {
        Object.keys(inventoryScan).map(async (data) => {
          inventoryScan[data] = inventoryScan[data].filter((
            { ProductNo }
          ) => inventoryFilter.Product.indexOf(ProductNo) > -1);
        });
      }

      if (inventoryFilter.hasOwnProperty('Sessions')) {
        let newData = [];
        const getData = [];
        const finalArr = [];
        const inventoryScanResPromiseAll = inventoryFilter.Sessions.map(
          async (sessionId) => new Promise(
            // eslint-disable-next-line no-async-promise-executor
            async (resolve) => {
              newData = await getInventoryBySessionID(sessionId);
              getData.push(newData);
              resolve(true);
            },
          )
        );
        await Promise.all(inventoryScanResPromiseAll);
        getData.map((item,) => {
          item.map((value) => {
            finalArr.push(value);
          });
        });
        const getProp = (prop) => (obj) => obj[prop];
        const getFoo = getProp('ProductNo');
        const arrProductNo = finalArr.map(getFoo);
        Object.keys(inventoryScan).map(async (data) => {
          inventoryScan[data] = inventoryScan[data].filter((
            item
          ) => arrProductNo.includes(item.ProductNo));
        });
      }

      // if (inventoryFilter.hasOwnProperty('Sessions')) {
      //   Object.keys(inventoryScan).map(async (data) => {
      //     inventoryScan[data] = inventoryScan[data].filter((
      //       { SessionID }
      //     ) => inventoryFilter.Sessions.indexOf(SessionID) > -1);
      //   });
      // }

      if (inventoryFilter.hasOwnProperty('ProductDescription')) {
        Object.keys(inventoryScan).map(async (data) => {
          const { ProductDescription } = inventoryFilter;
          inventoryScan[data] = inventoryScan[data].filter(
            (item) => ((item.ProductDescription !== null)
              && item.ProductDescription.indexOf(
                ProductDescription.toString().toUpperCase()
              ) > -1
            )
          );
        });
      }
      if (inventoryFilter.hasOwnProperty('LotNo')) {
        Object.keys(inventoryScan).map(async (data) => {
          inventoryScan[data] = inventoryScan[data].filter((
            { LotNo }
          ) => inventoryFilter.LotNo.indexOf(LotNo) > -1);
        });
      }

      if (inventoryFilter.hasOwnProperty('OrderBy')) {
        if (inventoryFilter.OrderBy[0] === 'PRODUCT #') {
          Object.keys(inventoryScan).map(async (data) => {
            inventoryScan[data] = inventoryScan[data].sort((a, b) => {
              const productA = a.ProductNo;
              const productB = b.ProductNo;
              return productA < productB ? -1 : 1; // for descending order
            });
          });
        }
      }

      if (inventoryFilter.hasOwnProperty('OrderBy')) {
        if (inventoryFilter.OrderBy[0] === 'SCAN ORDER (first to last)') {
          Object.keys(inventoryScan).map(async (data) => {
            inventoryScan[data] = inventoryScan[data].sort((a, b) => {
              const dateA = new Date(a.ScanDate).getTime();
              const dateB = new Date(b.ScanDate).getTime();
              return dateA < dateB ? -1 : 1; // for descending order
            });
          });
        }
      }

      if (inventoryFilter.hasOwnProperty('OrderBy')) {
        if (inventoryFilter.OrderBy[0] === 'SCAN ORDER (last to first)') {
          Object.keys(inventoryScan).map(async (data) => {
            inventoryScan[data] = inventoryScan[data].sort((a, b) => {
              const dateA = new Date(a.ScanDate).getTime();
              const dateB = new Date(b.ScanDate).getTime();
              return dateA < dateB ? 1 : -1; // for ascending/increasing order
            });
          });
        }
      }

      if (inventoryFilter.hasOwnProperty('isScanOnly')) {
        if (inventoryFilter.hasOwnProperty('AccountName')) {
          const accName = inventoryFilter.AccountName[0];
          const scanDataWithAccName = await getInventoryScanProductByAccNameAndType(accName);
          const ManualDataWithAccName = await getInventoryScanProductManualByAccNameAndType(
            accName
          );
          const ExtDeviceDataWithAccName = await getInventoryScanProductExtDevByAccNameAndType(
            accName
          );
          const mergeScanAndManual = scanDataWithAccName.concat(ManualDataWithAccName);
          const finalScanProducts = mergeScanAndManual.concat(ExtDeviceDataWithAccName);
          const getProp = (prop) => (obj) => obj[prop];
          const getFoo = getProp('ProductNo');
          const arrProductNo = finalScanProducts.map(getFoo);
          Object.keys(inventoryScan).map(async (data) => {
            inventoryScan[data] = inventoryScan[data].filter((
              item
            ) => arrProductNo.includes(item.ProductNo));
          });
        } else {
          const scanData = await getInventoryScanProductByType();
          const getProp = (prop) => (obj) => obj[prop];
          const getFoo = getProp('ProductNo');
          const arrProductNo = scanData.map(getFoo);
          Object.keys(inventoryScan).map(async (data) => {
            inventoryScan[data] = inventoryScan[data].filter((
              item
            ) => arrProductNo.includes(item.ProductNo)
              && Object.keys(inventoryScan).map(async (data1) => {
                inventoryScan[data1] = inventoryScan[data1].filter((
                  { InventoryType }
                ) => inventoryFilter.isScanOnly.indexOf(InventoryType) > -1);
              }));
          });
        }
        // Object.keys(inventoryScan).map(async (data) => {
        //   inventoryScan[data] = inventoryScan[data].filter((
        //     { InventoryType }
        //   ) => inventoryFilter.isScanOnly.indexOf(InventoryType) > -1);
        // });
      }

      if (inventoryFilter.hasOwnProperty('ExpireDate')) {
        Object.keys(inventoryScan).map(async (data) => {
          inventoryScan[data] = inventoryScan[data].filter(
            (item) => (item.ExpireDate !== null && item.ExpireDate !== ''
              && item.ExpireDate !== 'Invalid Date' && new Date(item.ExpireDate) <= new Date(inventoryFilter.ExpireDate[0]))
          );
        });
      }
      for (const key in inventoryScan) {
        const result = inventoryScan[key].filter((e) => e);
        if (result.length === 0 || result === '' || result === []) {
          delete inventoryScan[key];
        }
      }
      Object.keys(inventoryScan).map(async (data) => {
        inventoryScan[data] = inventoryScan[data].filter(
          (item) => (item.InventoryType !== null && item.InventoryType !== 'Null' && item.InventoryType !== '' && item.ProductNo !== '')
        );
      });
      setLoader(false);
      await this._onGetInventory(inventoryScan);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onShowScanOnly = (scanValue) => {
    try {
      const { setInventoryFilter, inventoryFilter, setLoader } = this.props;
      let msg = ' ';
      setLoader(true);
      if (scanValue === true) {
        this.setState({ isScanOnly: false }, () => {
          this._onGetInventoryProduct();
        });
        delete inventoryFilter.isScanOnly;
        setInventoryFilter(inventoryFilter);
      } else {
        this.setState({ isScanOnly: 'SCAN' }, () => {
          this._onGetInventoryProduct();
        });
        msg = 'SCAN';
        setInventoryFilter({
          ...inventoryFilter,
          isScanOnly: [msg]
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onHideVariants = (variant) => {
    try {
      const { setInventoryFilter, inventoryFilter, } = this.props;
      if (variant === true) {
        this.setState({ isChecked: false }, () => {
          this._onGetInventoryProduct();
        });
        setInventoryFilter({
          ...inventoryFilter,
          isChecked: ['notChecked']
        });
      } else {
        this.setState({ isChecked: 'checked' }, () => {
          this._onGetInventoryProduct();
        });
        setInventoryFilter({
          ...inventoryFilter,
          isChecked: ['checked']
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getScreenWidth = () => {
    this.setState({ screenWidth: window.screen.width });
  }

  _getNumberOfVisibleFilters = (filterCases) => {
    const count = Object.keys(filterCases).filter((crtKey) => crtKey !== 'Variance'
      && crtKey !== 'isChecked'
      && crtKey !== 'isScanOnly'
      && crtKey !== 'isExpire'
      && crtKey !== 'ExpiringDay'
      && crtKey !== 'OrderBy'
      && crtKey !== 'AccountName').length;
    return count;
  }

  async UNSAFE_componentWillMount() {
    try {
      const { inventoryFilter, setLoader } = this.props;
      for (const key in inventoryFilter) {
        const result = inventoryFilter[key].filter((e) => e);
        if (result.length === 0 || result === '' || result === []) {
          delete inventoryFilter[key];
        }
      }
      await this._getScreenWidth();
      setLoader(true);
      if (inventoryFilter.hasOwnProperty('isScanOnly')) {
        const { isScanOnly } = inventoryFilter;
        const exists = Object.values(isScanOnly).includes('SCAN');
        if (exists === true) {
          this.setState({
            isScanOnly: 'SCAN'
          });
        } else {
          this.setState({
            isScanOnly: 'notScan'
          });
        }
      }
      if (inventoryFilter.hasOwnProperty('isChecked')) {
        const { isChecked } = inventoryFilter;
        const exists = Object.values(isChecked).includes('checked');
        if (exists === true) {
          this.setState({
            isChecked: 'checked'
          });
        } else {
          this.setState({
            isChecked: 'notChecked'
          });
        }
      }
      await this._onGetInventoryProduct();

      // Update Filters after removing unused key-values
      let updatedFilters = _.omit(inventoryFilter, 'AccountName');
      if (inventoryFilter.hasOwnProperty('isScanOnly')) {
        updatedFilters = _.omit(updatedFilters, 'isScanOnly');
      }
      if (inventoryFilter.hasOwnProperty('OrderBy') && updatedFilters.OrderBy[0] === 'PRODUCT #') {
        updatedFilters = _.omit(updatedFilters, 'OrderBy');
      }
      if (inventoryFilter.hasOwnProperty('InventoryComparison')) {
        updatedFilters = _.omit(updatedFilters, 'Variance');
        updatedFilters = _.omit(updatedFilters, 'isChecked');
      }
      if (inventoryFilter.hasOwnProperty('isExpire')) {
        updatedFilters = _.omit(updatedFilters, 'isExpire');
        updatedFilters = _.omit(updatedFilters, 'ExpiringDay');
      }
      this.setState({
        filterCases: inventoryFilter,
        updatedFilters
      });

      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      filterCases, inventoryScan, isChecked, inventoryTypeCount, screenWidth, updatedFilters
    } = this.state;
    const { inventoryFilter } = this.props;
    return (
      <section className="list-section resizer-class">
        <Header
          title="View Inventory"
          goBack={this._goBack}
        />
        <section className="scan-view-inventory-section manage-session pb-5">
          <div className="container view-inventory-filter">
            <div className="row gx-3">
              {
                (filterCases && Object.keys(filterCases).map((key) => (
                  filterCases[key].map((item, id) => (
                    (key !== 'Variance' && key !== 'isChecked' && key !== 'isScanOnly' && key !== 'isExpire'
                      && key !== 'ExpiringDay' && item !== 'PRODUCT #' && key !== 'AccountName')
                      ? (
                        (screenWidth <= 800)
                          ? (
                            <div key={id} className="col-12">
                              <div className="selection selection-sm">
                                <p className="text-ellipsis-filter-ops">{key === 'isExpire' && key === 'ExpireDate'
                                  ? `EXPIRING on/after${moment(new Date(item)).format('M/DD/YY')}`
                                  : key === 'ExpireDate' ? `EXPIRING ${item}` : item}
                                </p>
                                {
                                  (filterCases.hasOwnProperty('AccountName') === true
                                    && this._getNumberOfVisibleFilters(filterCases) > 1)
                                  && (
                                    <button className="btn" onClick={() => this._onUnselectValue(key, id)}>
                                      <i className="fas fa-times" />
                                    </button>
                                  )
                                }
                              </div>
                            </div>
                          )
                          : (
                            <div key={id} className="col-6">
                              <div className="selection selection-sm">
                                <p className="text-ellipsis-filter-ops">{key === 'isExpire' && key === 'ExpireDate'
                                  ? moment(new Date(item)).format('M/DD/YY')
                                  : key === 'ExpireDate' ? `EXPIRING ${item}` : item}
                                </p>
                                {
                                  (filterCases.hasOwnProperty('AccountName') === true
                                    && this._getNumberOfVisibleFilters(filterCases) > 1)
                                  && (
                                    <button className="btn" onClick={() => this._onUnselectValue(key, id)}>
                                      <i className="fas fa-times" />
                                    </button>
                                  )
                                }
                              </div>
                            </div>
                          )

                      ) : ''
                  ))
                ))
                )
              }
            </div>
          </div>

          {
            Object.keys(inventoryScan).length > 0 ? Object.keys(inventoryScan)
              .map((value, index) => (
                <>
                  <div
                    className={`view-inv-tp view-int-acc ${(Object.keys(updatedFilters).length === 1) ? 'view-int-acc-1'
                      : Object.keys(updatedFilters).length === 2 ? 'view-int-acc-2'
                        : Object.keys(updatedFilters).length === 3 ? 'view-int-acc-3'
                          : Object.keys(updatedFilters).length === 4 ? 'view-int-acc-4'
                            : Object.keys(updatedFilters).length === 5 ? 'view-int-acc-5'
                              : Object.keys(updatedFilters).length === 6 ? 'view-int-acc-6'
                                : Object.keys(updatedFilters).length === 7 ? 'view-int-acc-7'
                                  : Object.keys(updatedFilters).length === 8 ? 'view-int-acc-8'
                                    : ''}`}
                    key={index}
                  >
                    <div className="container">
                      <div className="row">
                        <div className="col-12 view-int-product-row">
                          <p>{value}</p>
                        </div>
                      </div>
                    </div>
                    {/* </div> */}
                    <div className="view-inv-tp view-int-psc">
                      <div className="container">
                        <div className="row">
                          <div className="col-8">
                            <p />
                          </div>
                          <div className="col-4 align-self-end">
                            <div className="right-side">
                              <div className="row gx-2">
                                <div className="col-4">
                                  <p>P</p>
                                </div>
                                <div className="col-4">
                                  <p>C</p>
                                </div>
                                <div className="col-4">
                                  <p>S</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="view-inv-tp view-int-total">
                      <div className="container">
                        <div className="row">
                          <div className="col-8">
                            <p style={{ float: 'right' }}>Total Products</p>
                          </div>
                          <div className="col-4 total-product">
                            <div className="right-side">
                              {
                                Object.keys(inventoryTypeCount).map(
                                  (count) => (
                                    (value === count) && (
                                      <div className="row gx-2">
                                        <div className="col-4">
                                          {
                                            (value === count) && <p style={{ borderRight: '1px solid' }}>{inventoryTypeCount[count].PAR}</p>
                                          }
                                        </div>
                                        <div className="col-4">
                                          {
                                            (value === count)
                                            && <p style={{ borderRight: '1px solid' }}>{inventoryTypeCount[count].CONSIGN}</p>
                                          }
                                        </div>
                                        <div className="col-4">
                                          {
                                            (value === count && (filterCases.hasOwnProperty('Sessions') === true || inventoryFilter.hasOwnProperty('isScanOnly') === true))
                                            && <p>{inventoryTypeCount[count].SCAN}</p>
                                          }
                                        </div>
                                      </div>
                                    )
                                  )
                                )
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {
                      inventoryFilter.hasOwnProperty('InventoryComparison') === true
                      && (
                        <div className="view-inv-tp view-int-var">
                          <div className="container">
                            <div className="row">
                              <div className="col-8" />
                              <div className="col-4">
                                <div className="right-side">
                                  <div className="row gx-2">
                                    <div className="col-4">
                                      <p>{
                                        (inventoryFilter.InventoryComparison[0] === 'CONSIGNMENT vs SCANS (S-C)') ? 'C'
                                          : (inventoryFilter.InventoryComparison[0] === 'PAR vs CONSIGNMENT (C-P)') ? 'P'
                                            : (inventoryFilter.InventoryComparison[0] === 'PAR vs SCANS (S-P)') ? 'P' : ''
                                      }
                                      </p>
                                    </div>
                                    <div className="col-4">
                                      <p>{
                                        (inventoryFilter.InventoryComparison[0] === 'CONSIGNMENT vs SCANS (S-C)') ? 'S'
                                          : (inventoryFilter.InventoryComparison[0] === 'PAR vs CONSIGNMENT (C-P)') ? 'C'
                                            : (inventoryFilter.InventoryComparison[0] === 'PAR vs SCANS (S-P)') ? 'S' : ''
                                      }
                                      </p>
                                    </div>
                                    <div className="col-4">
                                      <p>V</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  </div>

                  <div className="view-inv-pro-group" style={{ borderBottom: '0px' }}>
                    {
                      inventoryScan[value].ProductNo.map((item, idx) => (
                        <>
                          <div
                            className="container" key={idx}
                            style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', position: 'relative' }}
                          >
                            <a
                              className="btn-down view-int-lot-info-row collapsed" data-bs-toggle="collapse"
                              href={`#viewInvDetails${item.ProductNo}`}
                              role="button" aria-expanded="false"
                              aria-controls={`viewInvDetails${item.ProductNo}`}
                            >&nbsp;
                            </a>
                            <div className="row">
                              <div className="col-8 view-int-product-row">
                                <p>{item.ProductNo}
                                  <a
                                    className="btn-down collapsed" data-bs-toggle="collapse"
                                    href={`#viewInvDetails${item.ProductNo}`}
                                    role="button" aria-expanded="false"
                                    aria-controls={`viewInvDetails${item.ProductNo}`}
                                  >
                                    <i className="icon-right fas fa-chevron-down" style={{ color: '#eda340' }} />
                                  </a>
                                </p>
                                <p className="mt-0">{item.ProductDescription}</p>
                              </div>
                              {
                                inventoryFilter.hasOwnProperty('InventoryComparison') === false
                                && (
                                  <div className="col-4">
                                    <div className="right-side">
                                      <div className="row gx-2">
                                        <div className="col-4">
                                          <p>{item.LotNo.reduce((sum, { PAR }) => sum + PAR, 0)}</p>
                                        </div>
                                        <div className="col-4">
                                          <p>
                                            {item.LotNo.reduce((sum,
                                              { CONSIGN }) => sum + CONSIGN, 0)}
                                          </p>
                                        </div>
                                        <div className="col-4">
                                          <p>
                                            {item.LotNo.reduce((sum, { SCAN }) => (SCAN !== 0
                                              ? sum + SCAN : ' '), 0)}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              }

                              {
                                inventoryFilter.hasOwnProperty('InventoryComparison') === true
                                && (
                                  <div className="col-4">
                                    <div className="right-side">
                                      <div className="row gx-2">
                                        <div className="col-4">
                                          <p>{inventoryFilter.InventoryComparison[0] === 'CONSIGNMENT vs SCANS (S-C)'
                                            ? item.LotNo.reduce((sum,
                                              { CONSIGN }) => sum + CONSIGN, 0)
                                            : inventoryFilter.InventoryComparison[0] === 'PAR vs CONSIGNMENT (C-P)'
                                              ? item.LotNo.reduce((sum, { PAR }) => sum + PAR, 0)
                                              : inventoryFilter.InventoryComparison[0] === 'PAR vs SCANS (S-P)'
                                                ? item.LotNo.reduce((sum, { PAR }) => sum + PAR, 0)
                                                : 0}
                                          </p>
                                        </div>
                                        <div className="col-4">
                                          <p>
                                            {inventoryFilter.InventoryComparison[0] === 'CONSIGNMENT vs SCANS (S-C)'
                                              ? item.LotNo.reduce((sum, { SCAN }) => sum + SCAN, 0)
                                              : inventoryFilter.InventoryComparison[0] === 'PAR vs CONSIGNMENT (C-P)'
                                                ? item.LotNo.reduce((sum,
                                                  { CONSIGN }) => sum + CONSIGN, 0)
                                                : inventoryFilter.InventoryComparison[0] === 'PAR vs SCANS (S-P)'
                                                  ? item.LotNo.reduce((sum,
                                                    { SCAN }) => sum + SCAN, 0)
                                                  : 0}
                                          </p>
                                        </div>
                                        <div className="col-4">
                                          {
                                            inventoryFilter.hasOwnProperty('Variance') === true
                                            && inventoryFilter.Variance[0] === 'PRODUCT'
                                            && (
                                              <p>
                                                {item.LotNo.reduce((sum,
                                                  { variance }) => sum + variance, 0)}
                                              </p>
                                            )
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          </div>
                          <div
                            className="collapse view-inv-details"
                            id={item.LotNo.find((o) => o.variance === 0)
                              && (inventoryFilter.hasOwnProperty('Variance') && inventoryFilter.Variance[0] === 'LOT' && isChecked === 'checked') ? '' : `viewInvDetails${item.ProductNo}`}
                          >
                            <div className="container pt-0 mt-0">
                              <div className="col-8">
                                <div className="left-side">
                                  <div className="row gx-2">
                                    <div className="col-7">
                                      <span>Lot #</span>
                                    </div>
                                    <div className="col-5 ps-0">
                                      <span>Exp Date</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {
                                item.LotNo.map((lot, key) => (
                                  <div className="row" key={key}>
                                    <div className="col-8">
                                      <div className="left-side">
                                        <div className="row gx-2">
                                          <div className="col-7">
                                            <p>{lot.LotNo}</p>
                                          </div>
                                          <div className="col-5">
                                            <p>{lot.ExpireDate !== 'Invalid date' ? lot.ExpireDate : ''}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {
                                      inventoryFilter.hasOwnProperty('InventoryComparison') === false
                                      && (
                                        <div className="col-4">
                                          <div className="right-side">
                                            <div className="row gx-2">
                                              <div className="col-4">
                                                <p>{lot.PAR}</p>
                                              </div>
                                              <div className="col-4">
                                                <p>{lot.CONSIGN}</p>
                                              </div>
                                              <div className="col-4">
                                                <p>{lot.SCAN}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    }

                                    {
                                      inventoryFilter.hasOwnProperty('InventoryComparison') === true
                                      && (
                                        <div className="col-4">
                                          <div className="right-side">
                                            <div className="row gx-2">
                                              <div className="col-4">
                                                <p>
                                                  {inventoryFilter.InventoryComparison[0] === 'CONSIGNMENT vs SCANS (S-C)'
                                                    ? lot.CONSIGN
                                                    : inventoryFilter.InventoryComparison[0] === 'PAR vs CONSIGNMENT (C-P)'
                                                      ? lot.PAR
                                                      : inventoryFilter.InventoryComparison[0] === 'PAR vs SCANS (S-P)'
                                                        ? lot.PAR
                                                        : 0}
                                                </p>
                                              </div>
                                              <div className="col-4">
                                                <p>{inventoryFilter.InventoryComparison[0] === 'CONSIGNMENT vs SCANS (S-C)'
                                                  ? lot.SCAN
                                                  : inventoryFilter.InventoryComparison[0] === 'PAR vs CONSIGNMENT (C-P)'
                                                    ? lot.CONSIGN
                                                    : inventoryFilter.InventoryComparison[0] === 'PAR vs SCANS (S-P)'
                                                      ? lot.SCAN
                                                      : 0}
                                                </p>
                                              </div>
                                              <div className="col-4">
                                                {
                                                  inventoryFilter.hasOwnProperty('Variance') === true
                                                    && inventoryFilter.Variance[0] === 'PRODUCT'
                                                    ? <p />
                                                    : (
                                                      <p>
                                                        {inventoryFilter.InventoryComparison[0] === 'CONSIGNMENT vs SCANS (S-C)'
                                                          ? lot.SCAN - lot.CONSIGN
                                                          : inventoryFilter.InventoryComparison[0] === 'PAR vs CONSIGNMENT (C-P)'
                                                            ? lot.CONSIGN - lot.PAR
                                                            : inventoryFilter.InventoryComparison[0] === 'PAR vs SCANS (S-P)'
                                                              ? lot.SCAN - lot.PAR
                                                              : 0}
                                                      </p>
                                                    )
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    }
                                  </div>
                                ))
                              }
                            </div>
                          </div>
                        </>
                      ))
                    }
                  </div>
                </>
              )) : <p className="no-data-available">No data available</p>
          }
          <section className="sets-footer-section fixed-bottom resizer-class p-0">
            <div className="container">
              <div className="button-block">
                {inventoryFilter.hasOwnProperty('isChecked') === false
                  ? (
                    <div className="row gx-3">
                      <div className="mb-2 mt-2">
                        <Link
                          type="checkbox"
                          className={`btn btn-theme-alt btn-theme-outline-alt w-100 ${inventoryFilter.hasOwnProperty('isScanOnly') === true
                            && inventoryFilter.isScanOnly[0] === 'SCAN' ? 'active' : ''}`}
                          onClick={() => this._onShowScanOnly(
                            inventoryFilter.hasOwnProperty('isScanOnly') === true
                            && inventoryFilter.isScanOnly[0] === 'SCAN'
                          )}
                          checked={inventoryFilter.hasOwnProperty('isScanOnly') === true ? inventoryFilter.isScanOnly[0] : 'notScan'}
                          readOnly
                        >Scans Only
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="row gx-3">
                      <div className="col-6 mb-2 mt-2">
                        <Link
                          type="checkbox"
                          className={`btn btn-theme-alt btn-theme-outline-alt w-100 ${inventoryFilter.hasOwnProperty('isChecked') === true
                            && inventoryFilter.isChecked[0] === 'checked' ? 'active' : ''}`}
                          onClick={() => this._onHideVariants(
                            inventoryFilter.hasOwnProperty('isChecked') === true
                            && inventoryFilter.isChecked[0] === 'checked'
                          )}
                          checked={inventoryFilter.hasOwnProperty('isChecked') === true && inventoryFilter.isChecked[0]}
                          readOnly
                        >Hide 0 Var
                        </Link>
                      </div>
                      <div className="col-6 mb-2 mt-2">

                        <Link
                          type="checkbox"
                          className={`btn btn-theme-alt btn-theme-outline-alt w-100 ${inventoryFilter.hasOwnProperty('isScanOnly') === true
                            && inventoryFilter.isScanOnly[0] === 'SCAN' ? 'active' : ''}`}
                          onClick={() => this._onShowScanOnly(
                            inventoryFilter.hasOwnProperty('isScanOnly') === true
                            && inventoryFilter.isScanOnly[0] === 'SCAN'
                          )}
                          checked={inventoryFilter.hasOwnProperty('isScanOnly') === true ? inventoryFilter.isScanOnly[0] : 'notScan'}
                          readOnly
                        >Scan Only
                        </Link>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </section>
        </section>
      </section>
    );
  }
}

export default withInventoryFilter(
  withLoader(
    withNotify(
      withGoBack(
        SessionFilter
      )
    )
  )
);
